import { render, staticRenderFns } from "./HousingModal.vue?vue&type=template&id=66d0b254&"
import script from "./HousingModal.vue?vue&type=script&lang=js&"
export * from "./HousingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports